import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDetailQuota, setState } from "./quotaCopySlice";
import CircleIcon from '@mui/icons-material/Circle';
import TableCellCheckbox from "./TableCellCheckbox";
import TableColCheckbox from "./TableColCheckbox";
import moment from "moment";

function quotaDetailsTableCol() {
	const columns = [
      { 
         field: "checkbox", 
         headerName: "checkbox" ,
         disableColumnMenu: true,
         hideSortIcons: true,
         filterable: false,
         width: 60,
         renderCell: TableCellCheckbox,
         renderHeader: (params) => {
            return <TableColCheckbox />;
         },
      },
		{ field: "scenarioName", headerName: "Scenario", flex:2, minWidth: 160, },
		{ field: "countryName", headerName: "Country", flex:1, minWidth: 100, },
      {  
         field: "criticalityId", 
         headerName: "Criticality", 
         flex:1,
         minWidth: 100,
         renderCell: Criticality
      },
		{ field: "quotaStatus", headerName: "Quota Status", flex:1, minWidth: 100, },
      {
			field: "timeDepletionSource",
			headerName: "Time Depletion (Source)",
			flex: 1.5,
			minWidth: 160,
		},
		{
			field: "periodTypeSource",
			headerName: "Period Structure (Source)",
			flex: 1.5,
			minWidth: 160,
		},
		{
			field: "previousTotalForecast",
			headerName: "Previous Total Quota",
			width: 160,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         }
		},
		{ field: "initialForecast", headerName: "Initial Quota", flex:1, minWidth: 100,      
         valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
         } },
		{ field: "totalForecast", headerName: "Total Quota", flex:1, minWidth: 100,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
      // { field: "sit", headerName: "SIT", width: 100 },
      { field: "unusedQuota", headerName: "Unused Quota - Previous Period", flex:1, minWidth: 160,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
      { 
         field: "lastActionDate", 
         headerName: "Last Action Date", 
         width: 160,
         valueGetter: (params) => {
            let date = params.row.lastActionDate;
            if (date === undefined || date === null || date === "") return "";
            date = String(date).split("T");
            return date[0];
         } ,
         valueFormatter: (params) => {
            if(params.value === "") return params.value;
            else{
            return moment(params.value).format('DD/MM/YYYY')
            }
         }
      },
		{ field: "lastActionBy", headerName: "Last Action By", flex:2, minWidth: 130, },
		{ field: "period", headerName: "Period", flex:1, minWidth: 100, },
	];
	return columns;
}

export default function Table() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.quotaCopy);
	const { quotaDetails, quotaDetailsTable, selectedTableRow } = state;
	const { rows } = quotaDetailsTable;
   const columns = quotaDetailsTableCol();

	function setRowSelected(selRow) {
		dispatch(setState("selectedTableRow", selRow));
		if (!selRow?.length) {
			dispatch(setState("selectedQuotaId", null));
			dispatch(setState("detailQuotaTable", null));
			return;
		}
		getDetailedQuota(selRow);
	}

	function getDetailedQuota(selRows) {
      dispatch(setState("detailQuotaTable", null));
      if(selRows.length > 0) {
         const quota = quotaDetails[selRows[selRows.length - 1]];

			const quotaID = quota.quotaID ?? quota.QuotaID;
			dispatch(setState("selectedQuotaId", quotaID ?? null));

         const obj = {
            quotaID,
            countryID: quota.geoID,
            scenarioID: quota.scenarioID,
            validityStartDate: quota.effectiveStartDate,
            validityEndDate: quota.effectiveEndDate,
				scenarioPeriodType: quota.periodType ?? quota.PeriodType ?? "",
         };
         console.log("Define_Quota Copy Submit_getDetailedQuota", obj);
         dispatch(getDetailQuota(obj));
      }
	}

	return (
		<Box sx={{ mt: 3 }}>
			<DataGrid
				rows={rows}
				columns={columns}
				onRowSelectionModelChange={(selectedRow) => {
					setRowSelected(selectedRow);
				}}
            disableColumnMenu
				rowSelectionModel={selectedTableRow}
			/>
		</Box>
	);
}

function Criticality(params) {

   const colors = [
      { id: 5, color: "blue.main" },
      { id: 4, color: "black.main" },
      { id: 3, color: "red.main" },
      { id: 2, color: "orange.main" },
      { id: 1, color: "green.main" },
   ];

   const color = colors.find(c => c.id === params.row.criticalityId).color;
   return (
      <Box>
         <CircleIcon sx={{ color: color }}/>
      </Box>
   );
}
